const AppWarning = ({
  className,
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) => <div className={`AppSpinner Warning ${className}`}>{children}</div>;

export default AppWarning;
